module.exports = __webpack_public_path__ + "img/product_105.7b08ded.webp";